"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
const axios_1 = __importDefault(require("axios"));
// import { I18n } from '@kiki/f2e.utils.locale.i18n';
let I18n;
if (typeof location !== 'undefined' || typeof ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NEXT_PUBLIC_API_ENV) !== 'undefined') {
    I18n = {
        locale: 'en'
    };
}
else {
    const I18nUtil = require("@kiki/f2e.utils.locale.i18n");
    I18n = I18nUtil.I18n;
}
const defaultOpt = {
    ignoreError: false,
    isSilent: false,
    needLogin: false,
};
const defaultErrorResponse = {
    code: 'system.error',
    msg: 'system or client request error',
    msgKey: 'system.error',
    msgParam: [],
    obj: {},
    success: false,
};
const joinParamsPost = function (params) {
    let language = '';
    const { locale } = I18n;
    language = locale;
    language = language.replace(/,/g, '');
    if (params.indexOf('language') === -1) {
        if (params.indexOf('?') >= 0) {
            params += `&language=${language}`;
        }
        else {
            params += `?language=${language}`;
        }
    }
    return params;
};
const getHeaders = (opts) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const baseHeader = {
        Accept: 'application/json;charset=utf-8',
        'Content-Type': 'application/json',
        saas_id: (_a = global.sass_id) !== null && _a !== void 0 ? _a : '',
        device_id: (_b = global.DEVICE_ID) !== null && _b !== void 0 ? _b : '',
        trace_id: (_c = global.traceId) !== null && _c !== void 0 ? _c : '',
        JWT_TOKEN: (_d = global.jwtKey) !== null && _d !== void 0 ? _d : '',
        device_type: (_e = global.device_type) !== null && _e !== void 0 ? _e : '',
        version: (_f = global.VERSION) !== null && _f !== void 0 ? _f : '',
        customer_id: (_g = global.USER_ID) !== null && _g !== void 0 ? _g : '',
        traffic: (_h = global.traffic) !== null && _h !== void 0 ? _h : '',
    };
    const heander = opts.verificationType === 1
        ? Object.assign(Object.assign({}, baseHeader), { 'SG-Verification-Type': opts.verificationType, 'SG-Verification-Sig': opts.sig, 'SG-Verification-Token': opts.token, 'SG-Verification-Scene': opts.scene, 'SG-Verification-Session-Id': opts.sessionId }) : (opts.Authorization
        ? Object.assign(Object.assign({}, baseHeader), { 'SG-Verification-Type': opts.verificationType, Authorization: opts.Authorization, 'SG-Verification-Session-Id': opts.sessionId }) : Object.assign(Object.assign({}, baseHeader), { MODE: (_j = opts.MODE) !== null && _j !== void 0 ? _j : '' }));
    return heander;
};
const getOptions = (url, method, headers, opts) => {
    var _a, _b, _c, _d, _e;
    const fetchOpt = {
        url,
        timeout: (_a = opts.timeout) !== null && _a !== void 0 ? _a : 5 * 1000,
        method,
        withCredentials: true,
        headers,
    };
    if (method === 'POST' || method === 'DELETE') {
        const _params = url.split('?')[1];
        if (_params) {
            // @ts-ignore
            fetchOpt.data = (((_b = opts.rawBody) !== null && _b !== void 0 ? _b : false) && opts.params) ? opts.params : JSON.parse(`{"${_params.replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`);
            // @ts-ignore
            fetchOpt.data.saas_id = (_c = global.sass_id) !== null && _c !== void 0 ? _c : '';
            // @ts-ignore
            fetchOpt.data.deviceId = (_d = global.DEVICE_ID) !== null && _d !== void 0 ? _d : '';
            // @ts-ignore
            fetchOpt.data.trace_id = (_e = global.traceId) !== null && _e !== void 0 ? _e : '';
        }
    }
    return fetchOpt;
};
const doRequest = function (method, url, opts) {
    return __awaiter(this, void 0, void 0, function* () {
        url = joinParamsPost(url);
        const startRequestTime = new Date().getTime();
        const headers = getHeaders(opts);
        const fetchOpt = getOptions(url, method, headers, opts);
        let responseData;
        try {
            // eslint-disable-next-line flowtype/no-weak-types
            const response = yield (0, axios_1.default)(fetchOpt);
            if (response.status !== 200) {
                console.log(response);
                return defaultErrorResponse;
            }
            responseData = response.data;
            if (responseData.msgKey === 'system.error') {
                throw new Error('system.error');
            }
            if (responseData.code === '500' || responseData.code === '405') {
                throw new Error('system.error');
            }
            return responseData;
        }
        catch (error) {
            throw new Error('system.error');
        }
    });
};
exports.request = {
    get(url, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return doRequest('GET', url, opts);
        });
    },
    post(url, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return doRequest('POST', url, opts);
        });
    },
    delete(url, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return doRequest('DELETE', url, opts);
        });
    },
    put(url, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return doRequest('PUT', url, opts);
        });
    },
};
//# sourceMappingURL=request.js.map